
define("rv!templates/booking/roomselection",[],function(){return { v:3,
  t:[ { t:7,
      e:"link",
      a:{ rel:"stylesheet",
        type:"text/css",
        href:"/fe/css/responsive.css?v=1006" } },
    " ",
    { t:7,
      e:"div",
      a:{ id:"room-selection" },
      f:[ { t:7,
          e:"div",
          a:{ "class":"row" },
          f:[ { t:7,
              e:"div",
              a:{ "class":"span8" },
              f:[ { t:7,
                  e:"div",
                  a:{ "class":"row" },
                  f:[ { t:7,
                      e:"div",
                      a:{ id:"roomselectionImage",
                        "class":"span4" },
                      f:[ { t:7,
                          e:"img",
                          a:{ style:"min-width:300px;",
                            src:[ { t:2,
                                r:"data.hotel.ImageUrl" } ],
                            alt:"",
                            "class":"shadowed" } } ] },
                    " ",
                    { t:7,
                      e:"div",
                      a:{ id:"roomselectionHotel",
                        "class":"span4" },
                      f:[ { t:7,
                          e:"h3",
                          f:[ { t:2,
                              r:"data.hotel.PublicName" } ] },
                        " ",
                        { t:7,
                          e:"br" },
                        " ",
                        { t:7,
                          e:"a",
                          a:{ "class":"btn",
                            onclick:"if (window.history.length<=2) {window.location.href='/#/hotel-new-search/';}else{window.history.go(-2);}" },
                          f:[ "Explore a Different Hotel" ] },
                        " ",
                        { t:7,
                          e:"br" },
                        { t:7,
                          e:"br" },
                        " ",
                        { t:7,
                          e:"a",
                          a:{ href:[ "/#/hotel-details/",
                              { t:2,
                                r:"data.hotel.HotelID" } ],
                            "class":"btn" },
                          f:[ "Back to Hotel Details" ] } ] } ] },
                " ",
                { t:7,
                  e:"br" },
                " ",
                { t:4,
                  f:[ { t:7,
                      e:"div",
                      a:{ style:"text-align: center;" },
                      f:[ { t:7,
                          e:"img",
                          a:{ style:"margin-top: 200px; height: 120px;",
                            src:"https://adestinn2blob.blob.core.windows.net/images/loading12102015-2.gif" } } ] } ],
                  n:50,
                  r:"checking" },
                { t:4,
                  n:51,
                  f:[ { t:4,
                      n:53,
                      f:[ { t:8,
                          r:"messenger" } ],
                      r:"messenger" },
                    " ",
                    { t:7,
                      e:"div",
                      a:{ id:"roomsList" },
                      f:[ { t:4,
                          f:[ { t:7,
                              e:"div",
                              a:{ style:"margin-left: 0px;",
                                "class":"row well" },
                              f:[ { t:7,
                                  e:"div",
                                  f:[ { t:4,
                                      f:[ { t:7,
                                          e:"img",
                                          a:{ "class":"shadowed roomImage",
                                            src:[ { t:2,
                                                r:"contentUrl" },
                                              "images/placeholder.gif" ],
                                            "data-original":[ { t:2,
                                                r:"RoomImage" } ],
                                            alt:"" } } ],
                                      n:50,
                                      x:{ r:[ "isNullOrWhiteSpace",
                                          "RoomImage" ],
                                        s:"!_0(_1)" } },
                                    " ",
                                    { t:7,
                                      e:"h5",
                                      f:[ { t:2,
                                          r:"Name" } ] },
                                    " ",
                                    { t:7,
                                      e:"p",
                                      f:[ { t:3,
                                          r:"Desc" } ] },
                                    " ",
                                    { t:7,
                                      e:"br",
                                      a:{ "class":"clear" } },
                                    " ",
                                    { t:7,
                                      e:"strong",
                                      f:[ "Guaranteed Best Available Rate: ",
                                        { t:2,
                                          x:{ r:[ "formatMoney",
                                              "Rate" ],
                                            s:"_0(_1)" } },
                                        " ",
                                        { t:4,
                                          f:[ { t:4,
                                              f:[ { t:7,
                                                  e:"a",
                                                  a:{ href:"#",
                                                    "class":"getRateDetails",
                                                    "data-track":[ "Room_Selection,view_rate_details,",
                                                      { t:2,
                                                        r:"data.hotel.HotelID" },
                                                      ",",
                                                      { t:2,
                                                        r:"RoomType" } ] },
                                                  v:{ click:"onGetRateDetails" },
                                                  f:[ "view rate details ",
                                                    { t:4,
                                                      f:[ "*" ],
                                                      n:50,
                                                      r:"HasRateChanges" } ] } ],
                                              n:50,
                                              x:{ r:[ "Nights" ],
                                                s:"_0==null" } } ],
                                          n:50,
                                          x:{ r:[ "loadingRateDetails" ],
                                            s:"!_0" } },
                                        { t:4,
                                          n:51,
                                          f:[ "loading..." ],
                                          x:{ r:[ "loadingRateDetails" ],
                                            s:"!_0" } },
                                        " ",
                                        { t:4,
                                          f:[ { t:7,
                                              e:"br" },
                                            "Resort Fees: ",
                                            { t:2,
                                              x:{ r:[ "formatMoney",
                                                  "Fees" ],
                                                s:"_0(_1)" } } ],
                                          n:50,
                                          x:{ r:[ "Fees" ],
                                            s:"_0>0" } } ] },
                                    " ",
                                    { t:4,
                                      f:[ { t:7,
                                          e:"img",
                                          a:{ src:[ { t:2,
                                                r:"contentUrl" },
                                              "images/destinationimages/page/arrow3.png?v=2" ],
                                            alt:"",
                                            "class":"ps-arrow" } } ],
                                      n:50,
                                      x:{ r:[ "isLinked" ],
                                        s:"!_0()" } },
                                    " ",
                                    { t:7,
                                      e:"br" },
                                    " ",
                                    { t:4,
                                      f:[ { t:8,
                                          r:"nightlyRates" } ],
                                      n:50,
                                      x:{ r:[ "Nights" ],
                                        s:"_0!=null" } },
                                    { t:4,
                                      n:51,
                                      f:[ { t:4,
                                          n:53,
                                          f:[ { t:8,
                                              r:"messenger" } ],
                                          r:"RateDetailsMessenger" } ],
                                      x:{ r:[ "Nights" ],
                                        s:"_0!=null" } },
                                    " ",
                                    { t:7,
                                      e:"a",
                                      a:{ href:"#perfectSaver",
                                        "class":"infoLink",
                                        "data-track":[ "Room_Selection,PerfectSaver,RibbonClick,",
                                          { t:2,
                                            x:{ r:[ "@index" ],
                                              s:"_0+1" } } ] },
                                      f:[ { t:7,
                                          e:"img",
                                          a:{ src:[ { t:2,
                                                r:"contentUrl" },
                                              "images/destinationimages/page/",
                                              { t:2,
                                                x:{ r:[ "getPerfectSaverImage",
                                                    "PsPreviewAmount" ],
                                                  s:"_0(_1)" } } ],
                                            alt:"PerfectSaver",
                                            style:"height: 32px; width: auto;" } } ] },
                                    " ",
                                    { t:7,
                                      e:"strong",
                                      f:[ { t:2,
                                          x:{ r:[ "getPerfectSaverMessage",
                                              "PsPreviewAmount",
                                              "availability.AchCount",
                                              "isLinked" ],
                                            s:"_0(_1,_2,_3())" } } ] },
                                    " ",
                                    { t:7,
                                      e:"a",
                                      a:{ href:"#perfectSaver",
                                        "class":"infoLink",
                                        "data-track":[ "Room_Selection,PerfectSaver,HelpClick,",
                                          { t:2,
                                            x:{ r:[ "@index" ],
                                              s:"_0+1" } } ] },
                                      f:[ { t:7,
                                          e:"img",
                                          a:{ src:[ { t:2,
                                                r:"contentUrl" },
                                              "images/ico-question.png" ],
                                            alt:"what's this" } } ] },
                                    " ",
                                    { t:7,
                                      e:"br" },
                                    " ",
                                    { t:7,
                                      e:"a",
                                      a:{ "class":"btn btn-primary right",
                                        style:"font-weight: bold;",
                                        href:[ { t:2,
                                            r:"BookingUrl" } ] },
                                      f:[ "Choose" ] } ] } ] } ],
                          n:52,
                          r:"availability.Rooms" },
                        " ",
                        { t:7,
                          e:"div",
                          a:{ id:"perfectSaver",
                            "class":"infoBox ps-infobox" },
                          f:[ { t:7,
                              e:"img",
                              a:{ src:[ { t:2,
                                    r:"contentUrl" },
                                  "images/destinationimages/page/perfectsaver_green_nospace.png?v=4" ],
                                alt:"PerfectSaver",
                                id:"imgPerfectSaver" } },
                            " ",
                            { t:7,
                              e:"br" },
                            { t:7,
                              e:"br" },
                            " ",
                            { t:4,
                              f:[ "This page shows an estimated price that does not include taxes and does not account for potential nightly rate changes. ",
                                { t:7,
                                  e:"br" },
                                { t:7,
                                  e:"br" },
                                " Click \"Choose\" to make PerfectSaver calculate exactly what you'll need to save to pay for this room." ],
                              n:50,
                              x:{ r:[ "isLinked" ],
                                s:"_0()" } },
                            " ",
                            { t:4,
                              f:[ "This is the amount you'd need to save with Adestinn per month for a year, for each night, to book this room. ",
                                { t:7,
                                  e:"br" },
                                { t:7,
                                  e:"br" },
                                " To book, you'll need to link your bank account ",
                                { t:7,
                                  e:"br" },
                                { t:7,
                                  e:"br" },
                                " ",
                                { t:7,
                                  e:"a",
                                  a:{ "class":"btn btn-primary",
                                    href:"/MyAccount/FinancialAccount.aspx?r=t",
                                    "data-track":"RoomSelection,LinkAccount,Click,1" },
                                  f:[ "Link My Bank Account" ] } ],
                              n:50,
                              x:{ r:[ "isLinked" ],
                                s:"!_0()" } } ] } ] } ],
                  r:"checking" } ] },
            " ",
            { t:7,
              e:"div",
              a:{ id:"roomselectionTraveler",
                "class":"span4" },
              f:[ { t:7,
                  e:"form",
                  v:{ submit:"onCheckAvailability" },
                  f:[ { t:7,
                      e:"table",
                      a:{ "class":"table table-bordered" },
                      f:[ { t:7,
                          e:"thead",
                          f:[ { t:7,
                              e:"tr",
                              f:[ { t:7,
                                  e:"th",
                                  f:[ { t:7,
                                      e:"i",
                                      a:{ "class":"icon-user" } } ] },
                                " ",
                                { t:7,
                                  e:"th",
                                  f:[ "Travelers" ] } ] } ] },
                        " ",
                        { t:7,
                          e:"tbody",
                          f:[ { t:7,
                              e:"tr",
                              f:[ { t:7,
                                  e:"td" },
                                " ",
                                { t:7,
                                  e:"td",
                                  f:[ "Adults ",
                                    { t:7,
                                      e:"div",
                                      a:{ "class":"input-prepend right" },
                                      f:[ { t:7,
                                          e:"span",
                                          a:{ "class":"add-on" },
                                          f:[ "#" ] },
                                        " ",
                                        { t:7,
                                          e:"select",
                                          v:{ change:"clearRooms" },
                                          a:{ value:[ { t:2,
                                                r:"data.planningData.TravelerInfo.AdultCount" } ],
                                            style:"width: 50px; margin-left: -6px;" },
                                          f:[ { t:4,
                                              f:[ { t:7,
                                                  e:"option",
                                                  a:{ value:[ { t:2,
                                                        r:"." } ] },
                                                  f:[ { t:2,
                                                      r:"." } ] } ],
                                              n:52,
                                              x:{ r:[  ],
                                                s:"[1,2,3,4,5,6,7,8]" } } ] } ] },
                                    " ",
                                    { t:7,
                                      e:"br",
                                      a:{ "class":"clear" } } ] } ] },
                            " ",
                            { t:7,
                              e:"tr",
                              f:[ { t:7,
                                  e:"td" },
                                " ",
                                { t:7,
                                  e:"td",
                                  f:[ { t:4,
                                      f:[ { t:7,
                                          e:"div",
                                          f:[ { t:7,
                                              e:"strong",
                                              f:[ "What name is this reservation under?" ] },
                                            " ",
                                            { t:7,
                                              e:"br" },
                                            " ",
                                            { t:4,
                                              f:[ { t:7,
                                                  e:"label",
                                                  f:[ { t:7,
                                                      e:"input",
                                                      a:{ type:"radio",
                                                        name:[ { t:2,
                                                            r:"data.planningData.TravelerInfo.CoMemberBook" } ],
                                                        value:"false" },
                                                      v:{ focus:"clearRooms" } },
                                                    " ",
                                                    { t:2,
                                                      r:"data.user.NameFirst" },
                                                    " ",
                                                    { t:2,
                                                      r:"data.user.NameLast" } ] },
                                                " ",
                                                { t:7,
                                                  e:"br" } ],
                                              n:50,
                                              x:{ r:[ "isMAW" ],
                                                s:"!_0" } },
                                            " ",
                                            { t:7,
                                              e:"label",
                                              f:[ { t:7,
                                                  e:"input",
                                                  v:{ focus:"clearRooms" },
                                                  a:{ type:"radio",
                                                    name:[ { t:2,
                                                        r:"data.planningData.TravelerInfo.CoMemberBook" } ],
                                                    value:"true" },
                                                  m:[ { t:4,
                                                      f:[ "checked=\"checked\"" ],
                                                      n:50,
                                                      r:"isMAW" } ] },
                                                " ",
                                                { t:4,
                                                  f:[ " ",
                                                    { t:7,
                                                      e:"input",
                                                      a:{ type:"text",
                                                        name:"altName",
                                                        value:[ { t:2,
                                                            r:"data.planningData.TravelerInfo.CoMemberAltName" } ],
                                                        placeholder:"Enter onetime booking name",
                                                        style:"width: 175px;" },
                                                      v:{ focus:"clearRooms" } },
                                                    " ",
                                                    { t:7,
                                                      e:"br" },
                                                    "       ",
                                                    { t:7,
                                                      e:"strong",
                                                      f:[ "Default:" ] },
                                                    " ",
                                                    { t:2,
                                                      r:"data.user.CoTraveler" },
                                                    " " ],
                                                  n:50,
                                                  x:{ r:[ "isDba",
                                                      "isMAW" ],
                                                    s:"_0||_1" } },
                                                { t:4,
                                                  n:51,
                                                  f:[ { t:2,
                                                      r:"data.user.CoTraveler" } ],
                                                  x:{ r:[ "isDba",
                                                      "isMAW" ],
                                                    s:"_0||_1" } } ] } ] },
                                        " ",
                                        { t:7,
                                          e:"br" } ],
                                      n:50,
                                      x:{ r:[ "data.user.CoTraveler" ],
                                        s:"_0!=null" } },
                                    " ",
                                    { t:7,
                                      e:"strong",
                                      f:[ "Phone" ] },
                                    " ",
                                    { t:7,
                                      e:"br" },
                                    " ",
                                    { t:7,
                                      e:"input",
                                      a:{ type:"text",
                                        value:[ { t:2,
                                            r:"data.user.Phone" } ] },
                                      v:{ change:"onPhoneChange" } } ] } ] },
                            " ",
                            { t:7,
                              e:"tr",
                              f:[ { t:7,
                                  e:"td" },
                                " ",
                                { t:7,
                                  e:"td",
                                  f:[ "Children ",
                                    { t:7,
                                      e:"div",
                                      a:{ "class":"input-prepend right" },
                                      f:[ { t:7,
                                          e:"span",
                                          a:{ "class":"add-on" },
                                          f:[ "#" ] },
                                        " ",
                                        { t:7,
                                          e:"select",
                                          v:{ change:"onChildrenChange" },
                                          a:{ value:[ { t:2,
                                                r:"data.planningData.TravelerInfo.ChildAges.length" } ],
                                            style:"width: 50px; margin-left: -6px;" },
                                          f:[ { t:4,
                                              f:[ { t:7,
                                                  e:"option",
                                                  a:{ value:[ { t:2,
                                                        r:"." } ] },
                                                  f:[ { t:2,
                                                      r:"." } ] } ],
                                              n:52,
                                              x:{ r:[  ],
                                                s:"[0,1,2,3,4,5]" } } ] } ] } ] } ] },
                            " ",
                            { t:4,
                              f:[ { t:7,
                                  e:"tr",
                                  f:[ { t:7,
                                      e:"td" },
                                    " ",
                                    { t:7,
                                      e:"td",
                                      f:[ { t:4,
                                          f:[ "Child's age:  ",
                                            { t:7,
                                              e:"select",
                                              a:{ value:[ { t:2,
                                                    rx:{ r:"data.planningData.TravelerInfo.ChildAges",
                                                      m:[ { t:30,
                                                          n:"@index" } ] } } ],
                                                "class":"input-mini" },
                                              f:[ { t:4,
                                                  f:[ { t:7,
                                                      e:"option",
                                                      a:{ value:[ { t:2,
                                                            r:"." } ] },
                                                      f:[ { t:2,
                                                          r:"." } ] } ],
                                                  n:52,
                                                  r:"childOptions" } ] },
                                            " ",
                                            { t:7,
                                              e:"br" } ],
                                          n:52,
                                          r:"data.planningData.TravelerInfo.ChildAges" } ] } ] } ],
                              n:50,
                              x:{ r:[ "data.planningData.TravelerInfo.ChildAges.length",
                                  "data.hotel.IsAdultAge" ],
                                s:"_0>0&&_1!==1" } },
                            " ",
                            { t:7,
                              e:"tr",
                              f:[ { t:7,
                                  e:"th",
                                  f:[ { t:7,
                                      e:"i",
                                      a:{ "class":"icon-calendar" } } ] },
                                " ",
                                { t:7,
                                  e:"th",
                                  f:[ "Arrive / Depart" ] } ] },
                            " ",
                            { t:7,
                              e:"tr",
                              f:[ { t:7,
                                  e:"td" },
                                " ",
                                { t:7,
                                  e:"td",
                                  f:[ { t:4,
                                      f:[ { t:7,
                                          e:"div",
                                          f:[ { t:7,
                                              e:"input",
                                              a:{ id:"chkShowGDSData",
                                                type:"checkbox",
                                                autocomplete:"off",
                                                checked:[ { t:2,
                                                    r:"showGdsData" } ] } },
                                            " ",
                                            { t:7,
                                              e:"label",
                                              a:{ "for":"chkShowGDSData" },
                                              f:[ "Show GDS Room Descriptions" ] } ] } ],
                                      n:50,
                                      r:"isDba" },
                                    " ",
                                    { t:4,
                                      f:[ { t:7,
                                          e:"div",
                                          a:{ style:"margin-bottom: 4px;" },
                                          f:[ "Minimum Stay: ",
                                            { t:7,
                                              e:"strong",
                                              f:[ { t:2,
                                                  r:"data.hotel.MinStayRange" } ] } ] } ],
                                      n:50,
                                      x:{ r:[ "data.hotel.MinStayRange" ],
                                        s:"_0!=null" } },
                                    " ",
                                    { t:7,
                                      e:"input",
                                      a:{ type:"text",
                                        id:"dateRange",
                                        autocomplete:"false" },
                                      v:{ change:"onDateBoxChange" } } ] } ] },
                            " ",
                            { t:7,
                              e:"tr",
                              f:[ { t:7,
                                  e:"th",
                                  f:[ { t:7,
                                      e:"i",
                                      a:{ "class":"icon-map-marker" } } ] },
                                " ",
                                { t:7,
                                  e:"th",
                                  f:[ "Destination" ] } ] },
                            " ",
                            { t:7,
                              e:"tr",
                              f:[ { t:7,
                                  e:"td" },
                                " ",
                                { t:7,
                                  e:"td",
                                  f:[ { t:2,
                                      r:"data.hotel.RegionName" } ] } ] },
                            " ",
                            { t:7,
                              e:"tr",
                              f:[ { t:7,
                                  e:"td" },
                                " ",
                                { t:7,
                                  e:"td",
                                  a:{ colspan:"2" },
                                  f:[ { t:7,
                                      e:"button",
                                      a:{ type:"submit",
                                        "class":"btn btn-primary",
                                        onClick:"window.scroll(0,400);" },
                                      m:[ { t:4,
                                          f:[ "disabled=\"disabled\"" ],
                                          n:50,
                                          r:"checking" } ],
                                      f:[ { t:4,
                                          f:[ "Checking..." ],
                                          n:50,
                                          r:"checking" },
                                        { t:4,
                                          n:51,
                                          f:[ "Check Availability" ],
                                          r:"checking" } ] } ] } ] } ] } ] } ] },
                " ",
                { t:4,
                  f:[ { t:4,
                      f:[ { t:7,
                          e:"form",
                          v:{ submit:"onManualBook" },
                          a:{ "class":"well",
                            id:"manaulBookingForm" },
                          f:[ { t:7,
                              e:"h2",
                              f:[ "Manual Book" ] },
                            " Confirmation Number* ",
                            { t:7,
                              e:"br" },
                            " ",
                            { t:7,
                              e:"input",
                              a:{ type:"text",
                                value:[ { t:2,
                                    r:"data.planningData.ManualBooking.ConfirmationNumber" } ] } },
                            " ",
                            { t:7,
                              e:"br" },
                            " Room Type Code* ",
                            { t:7,
                              e:"span",
                              a:{ "class":"sideNote" },
                              f:[ "(e.g. \"1BR\")" ] },
                            " ",
                            { t:7,
                              e:"br" },
                            " ",
                            { t:7,
                              e:"input",
                              a:{ type:"text",
                                value:[ { t:2,
                                    r:"data.planningData.DestinationInfo.RoomTypeCode" } ] } },
                            " ",
                            { t:7,
                              e:"br" },
                            " Rate Plan Code ",
                            { t:7,
                              e:"span",
                              a:{ "class":"sideNote" },
                              f:[ "(aka \"RateCode\", probably either ADN or OGADN1)" ] },
                            " ",
                            { t:7,
                              e:"br" },
                            " ",
                            { t:7,
                              e:"input",
                              a:{ type:"text",
                                value:[ { t:2,
                                    r:"data.planningData.DestinationInfo.Rate.RatePlanCode" } ] } },
                            " ",
                            { t:7,
                              e:"br" },
                            " Room Name* ",
                            { t:7,
                              e:"br" },
                            " ",
                            { t:7,
                              e:"input",
                              a:{ type:"text",
                                value:[ { t:2,
                                    r:"data.planningData.DestinationInfo.RoomName" } ] } },
                            " ",
                            { t:7,
                              e:"br" },
                            " Room Description ",
                            { t:7,
                              e:"br" },
                            " ",
                            { t:7,
                              e:"textarea",
                              a:{ value:[ { t:2,
                                    r:"data.planningData.ManualBooking.RoomDescription" } ] } },
                            " ",
                            { t:7,
                              e:"br" },
                            " Corporate Discount Code* ",
                            { t:7,
                              e:"br" },
                            " ",
                            { t:7,
                              e:"input",
                              a:{ type:"text",
                                value:[ { t:2,
                                    r:"data.planningData.DestinationInfo.RoomCorporateDisc" } ],
                                style:"width: 50px;" } },
                            " ",
                            { t:7,
                              e:"span",
                              a:{ "class":"sideNote" },
                              f:[ "(probably either ADN or OGADN1)" ] },
                            " ",
                            { t:7,
                              e:"br" },
                            " Room Rate (for all nights)* ",
                            { t:7,
                              e:"br" },
                            " ",
                            { t:7,
                              e:"input",
                              a:{ type:"text" },
                              o:{ n:"calculator",
                                a:"data.planningData.DestinationInfo.Rate.RoomRateTotal" } },
                            " ",
                            { t:7,
                              e:"br" },
                            " Room Tax* ",
                            { t:7,
                              e:"br" },
                            " ",
                            { t:7,
                              e:"input",
                              a:{ type:"text" },
                              o:{ n:"calculator",
                                a:"data.planningData.DestinationInfo.Rate.HotelTaxFeeTotal" } },
                            " ",
                            { t:7,
                              e:"br" },
                            " Room Fee* ",
                            { t:7,
                              e:"br" },
                            " ",
                            { t:7,
                              e:"input",
                              a:{ type:"text" },
                              o:{ n:"calculator",
                                a:"data.planningData.DestinationInfo.Rate.HotelFeeTotal" } },
                            " Recovery Fee* ",
                            { t:7,
                              e:"br" },
                            " ",
                            { t:7,
                              e:"input",
                              a:{ type:"text" },
                              o:{ n:"calculator",
                                a:"data.planningData.DestinationInfo.Rate.RecoveryFee" } },
                            " ",
                            { t:7,
                              e:"br" },
                            " Policies* ",
                            { t:7,
                              e:"br" },
                            " ",
                            { t:7,
                              e:"textarea",
                              a:{ value:[ { t:2,
                                    r:"data.planningData.ManualBooking.CancellationPolicy" } ] } },
                            " ",
                            { t:7,
                              e:"br" },
                            " Comments for Manual Booking* ",
                            { t:7,
                              e:"br" },
                            " ",
                            { t:7,
                              e:"textarea",
                              a:{ value:[ { t:2,
                                    r:"data.planningData.ManualBooking.Comments" } ] } },
                            " ",
                            { t:7,
                              e:"br" },
                            " ",
                            { t:7,
                              e:"button",
                              a:{ type:"submit",
                                "class":"btn btn-primary" },
                              f:[ "Continue" ] } ] } ],
                      n:50,
                      x:{ r:[ "data.hotel.LookupSource" ],
                        s:"_0.toLowerCase()!==\"adestinn\"" } },
                    { t:4,
                      n:51,
                      f:[ { t:7,
                          e:"div",
                          a:{ "class":"alert alert-info" },
                          f:[ "Manual Booking cannot be performed. This is an ASRS hotel. Note, DBAs can bypass min stay length." ] } ],
                      x:{ r:[ "data.hotel.LookupSource" ],
                        s:"_0.toLowerCase()!==\"adestinn\"" } } ],
                  n:50,
                  r:"isDba" } ] } ] } ] } ] };});
